var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0834 4.8625C16.2727 3.743 15.2079 2.83182 13.9765 2.20383C12.7451 1.57583 11.3824 1.24894 10.0001 1.25C5.4776 1.25 1.75844 4.67917 1.2976 9.08L1.21094 9.90834L2.86927 10.0825L2.9551 9.25334C3.11032 7.78651 3.71952 6.40471 4.69772 5.30072C5.67591 4.19672 6.97432 3.4256 8.41179 3.09493C9.84927 2.76425 11.3541 2.89052 12.7164 3.45612C14.0786 4.02172 15.2304 4.99843 16.0109 6.25H12.9168V7.91667H18.7501V2.08334H17.0834V4.8625ZM17.1309 9.9175L17.0443 10.7467C16.8888 12.2133 16.2796 13.5948 15.3014 14.6985C14.3233 15.8023 13.0251 16.5733 11.5878 16.9039C10.1505 17.2346 8.64591 17.1084 7.28379 16.543C5.92166 15.9776 4.76994 15.0012 3.98927 13.75H7.08344V12.0833H1.2501V17.9167H2.91677V15.1375C3.72754 16.257 4.79234 17.1682 6.0237 17.7962C7.25506 18.4242 8.61785 18.7511 10.0001 18.75C14.5218 18.75 18.2418 15.3208 18.7018 10.92L18.7884 10.0917L17.1309 9.9175Z",
    fill: "#1A2425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.273aa75d71b959e9651f15ffaefc54b3.svg";
export { ForwardRef as ReactComponent };